import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePwaStore = defineStore('pwa', () => {
  const deferredPrompt = ref(null);
  const isInstallable = ref(false);

  console.log("IN PWA definte store")

  // 1. Setup the native browser event listener IMMEDIATELY
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt.value = e;
    isInstallable.value = true;
    console.log('✅ Pinia caught the event! isInstallable is now true.');
  });

  window.addEventListener('appinstalled', () => {
    console.log("app installed")
    deferredPrompt.value = null;
    isInstallable.value = false;
  });

  // 2. Action to trigger when clicking your custom tile
  const installApp = async () => {
    if (!deferredPrompt.value) return;

    deferredPrompt.value.prompt();
    const { outcome } = await deferredPrompt.value.userChoice;
    console.log(`User choice: ${outcome}`);

    deferredPrompt.value = null;
    isInstallable.value = false;
  };

  return {
    isInstallable,
    installApp
  };
});